'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//context
var TRANSLATION_CONTEXT = exports.TRANSLATION_CONTEXT = 'quickdeposit';

// REDUX-FORM constants
var QD_RF_FIELD_CARDID = exports.QD_RF_FIELD_CARDID = 'cardId';

// error related constants
var QD_GENERIC_ERROR_CODE = exports.QD_GENERIC_ERROR_CODE = 'QD_ERR_GEN';
var QD_GENERIC_ERROR_MESSAGE = exports.QD_GENERIC_ERROR_MESSAGE = 'An error occurred while performing this operation';
var QDL_MISSING_CUSTOMER_DETAILS_MSG = exports.QDL_MISSING_CUSTOMER_DETAILS_MSG = 'Missing customer details';
var QDL_NO_METHOD_DETAILS_MSG = exports.QDL_NO_METHOD_DETAILS_MSG = 'No method details were provided';